<template>
  <modal :show="true" headerClasses="justify-content-center" :showClose='false' :no-close-on-backdrop="true">

    <div class="container">
      <div class="row" style="margin-top:3em">
        <div class="col-12 d-flex justify-content-center">
          <p v-if="callType=='incoming'">{{$t("message.Incoming Call")}}</p>
          <p v-if="callType=='outgoing'">{{$t("message.Calling")}}...</p>
        </div>
      </div>
      <div class="row modal-image">
        <div class="col-12 d-flex justify-content-center">
          <div class="call-ripple">
            <span style="display: flex;justify-content: center;align-items: center;">
              <img :src="caller.img" alt="" style="width: 100%; height: 100%; border-radius: 50%;" v-if="caller.img">
              <img :src="require('@/assets/img/proAvatar.png')" alt="avatar" v-if="!caller.img" class="avatar border-gray"
                style="width: 100%; height: 100%; border-radius: 50%;" />
            </span>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 3em;">
        <div class="col-12 d-flex justify-content-center">
          <h5>{{caller.name}}</h5>
        </div>
      </div>
      <div class="row call-buttons-div">
        <div class="col-12 d-flex justify-content-center">
          <div style="margin-right: 6em;" v-if="callType=='incoming'">
            <n-button type="danger" class="call-button" @click.native="declineCall">
              <i class="fas fa-phone-slash" style="font-size: 2em;"></i>
            </n-button>
            <span style="margin-inline-start: 1em;">{{$t("message.Decline")}}</span>
          </div>
          <div v-if="callType=='incoming'">
            <n-button type="info" class="call-button" @click.native="connectToCall">
              <i class="fas fa-phone" style="font-size: 2em;"></i>
            </n-button>
            <span style="margin-inline-start: 1em;">{{$t("message.Accept")}}</span>
          </div>
          <div v-if="callType=='outgoing'">
            <n-button type="danger" class="call-button" @click.native="cancelCall">
              <i class="fas fa-phone-slash" style="font-size: 2em;"></i>
            </n-button>
            <span style="margin-inline-start: 1em;">Cancel</span>
          </div>
        </div>
      </div>
    </div>

    <template slot="footer">
    </template>
  </modal>
</template>

<script>
export default {
  props: ["caller", "callType"],
  data() {
    return {
      ringtone: new Audio(require("@/assets/audio/ringtone.wav")),
      callTimeoutHandle: null,
    };
  },
  methods: {
    stopRingtone() {
      this.ringtone.pause();
      this.ringtone.currentTime = 0;
    },
    declineCall() {
      this.stopRingtone();
      this.$emit("call-declined");
      clearTimeout(this.callTimeoutHandle);
    },
    connectToCall() {
      this.stopRingtone();
      this.$emit("call-accepted");
      clearTimeout(this.callTimeoutHandle);
    },
    cancelCall() {
      this.stopRingtone();
      this.$emit("call-cancelled");
      clearTimeout(this.callTimeoutHandle);
    },
    callMissed() {
      this.stopRingtone();
      this.$emit("call-missed");
    },
  },
  mounted() {
    this.ringtone.play();
    this.callTimeoutHandle = setTimeout(() => {
      this.callMissed();
    }, 30000);
  },
  beforeDestroy() {
    this.stopRingtone();
    clearTimeout(this.callTimeoutHandle);
  },
};
</script>

<style scoped>
/* ripple css */
.call-ripple {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 150px;
  border-radius: 100%;
  background: #fff;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);
  z-index: 1;
}
.call-ripple span {
  position: relative;
  font-size: 72px;
  height: 100%;
  width: 100%;
}
.call-ripple::after {
  opacity: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  inset-inline-end: 0;
  bottom: 0;
  content: "";
  height: 100%;
  width: 100%;
  border: 8px solid rgba(0, 0, 0, 0.2);
  border-radius: 100%;
  animation-name: ripple;
  animation-duration: 3s;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);
  z-index: -1;
}
.call-ripple::before {
  opacity: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  inset-inline-end: 0;
  bottom: 0;
  content: "";
  height: 100%;
  width: 100%;
  border: 8px solid rgba(0, 0, 0, 0.2);
  border-radius: 100%;
  animation-name: ripple;
  animation-duration: 3s;
  animation-delay: 0.5s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);
  z-index: -1;
}
@keyframes ripple {
  from {
    opacity: 1;
    transform: scale3d(0.75, 0.75, 1);
  }
  to {
    opacity: 0;
    transform: scale3d(1.5, 1.5, 1);
  }
}

.call-button {
  border-radius: 1.5em;
  height: 5em;
  display: block;
}

.call-buttons-div {
  margin-top: 6em;
}
.modal-image {
  margin-top: 5em;
}

@media (max-width: 450px) {
  /deep/ .modal-content {
    height: 100vh;
  }
  /deep/ .modal-dialog {
    margin: 0;
  }
  /deep/ .modal {
    pointer-events: none;
  }
  /deep/ .call-buttons-div {
    margin-top: 14em;
  }
  /deep/ .modal-image {
    margin-top: 7em;
  }
}

@media (max-height: 721px) {
  /deep/ .call-buttons-div {
    margin-top: 1em;
  }
}
</style>
